import Vue from 'vue'
import App from './App.vue'
import less from 'less'
import router from './router'
import request from '@/assets/util/request'   //ajax请求
import directives from '@/assets/util/directives'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/base.css';
Vue.use(directives);
Vue.use(less)
Vue.config.productionTip = false
Vue.prototype.$http = request;
Vue.use(ElementUI);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

router.afterEach(() => {
  window.scrollTo(0,0);
})
